if (!customElements.get('info-modal')) {

  class InfoModal extends HTMLElement {

    constructor() {
      super();
      this.curtain = this.querySelector('[data-info-modal-curtain]');
      this.content = this.querySelector('[data-info-modal-content]');
      this.btnClose = this.querySelector('[data-info-modal-close]');
      this.setupEventListeners();
    }

    setupEventListeners() {
      this.btnClose.addEventListener('click', e => {
        this.close();
      });
      this.curtain.addEventListener('click', e => {
        this.close();
      });
    }

    openWith(template) {
      console.log(template.innerHTML);
      this.content.appendChild(template);
      this.classList.add('info-modal--is-visible');
    }

    empty(el) {
      while(el.firstChild) {
        el.removeChild(el.firstChild);
      }
    }

    close() {
      this.classList.remove('info-modal--is-visible');
      setTimeout(() => {
        this.empty(this.content);
      }, 300);
    }

  }

  customElements.define('info-modal', InfoModal);

}